<script>
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	// Stores
	import MarketGroupStore from '@/Stores/Sport/MarketGroupStore';
	import MarketStore from '@/Stores/Sport/MarketStore.js';

	export let market = undefined;
	export let marketGroupId = undefined;
	export let event = undefined;

	export let open = false;

	let sending = false;

	window.scrollTo(0, 0);

	$: eventName = event && market && getEventName();
	$: marketName = (event && market && market.name) ?? '';

	$: currentMarketLineValue = event && market && market.line;
	$: newMarketLineValue = currentMarketLineValue;

	let errors = null;

	function getEventName() {
		if (market !== undefined) {
			return event.name + ' - ' + market.name;
		}

		return '';
	}

	function alterLine(adjustmentValue) {
		newMarketLineValue = newMarketLineValue + adjustmentValue;
	}

	function updateMarketLineValue() {
		if (newMarketLineValue <= 0) {
			errors = {};
			errors['new_market_line_value'] = ['Market line must be greater than 0'];
			return false;
		}
		sending = true;
		market
			.adjustLineValue(newMarketLineValue)
			.then(() => {
				notify({
					type: 'success',
					title: eventName,
					message: 'Market line successfully updated',
					timeout: 3
				});
				if (marketGroupId) {
					MarketGroupStore.getMarketGroupDetails(marketGroupId, event.id);
				} else {
					MarketStore.getMarketWithSelections(market.id);
				}
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to alter market line',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open && market}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 mb-2 text-xl font-bold text-center">Adjust "{marketName}" Line Value</h2>
		<div class="pt-1 text-center">{eventName}</div>
		<div class="flex justify-center py-2 space-x-4">
			<p>
				Current Market Line Value: {market.line}
			</p>
		</div>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<div class="flex justify-center mb-4 space-x-4">
				<button class="btn btn-danger" on:click={() => alterLine(-25)}>-25</button>
				<button class="btn btn-danger" on:click={() => alterLine(-10)}>-10</button>
				<button class="btn btn-danger" on:click={() => alterLine(-5)}>-5</button>
				<button class="btn btn-danger" on:click={() => alterLine(-1)}>-1</button>
				<button class="btn btn-danger" on:click={() => alterLine(-0.5)}>-0.5</button>
				<button class="btn btn-primary" on:click={() => alterLine(0.5)}>+0.5</button>
				<button class="btn btn-primary" on:click={() => alterLine(1)}>+1</button>
				<button class="btn btn-primary" on:click={() => alterLine(5)}>+5</button>
				<button class="btn btn-primary" on:click={() => alterLine(10)}>+10</button>
				<button class="btn btn-primary" on:click={() => alterLine(25)}>+25</button>
			</div>
			<div class="flex flex-row mb-2 justify-center items-center">
				<div>New Market Line Value:</div>
				<TextInput
					name={'new_market_line_value'}
					type="number"
					required={true}
					className="text-left ml-3"
					placeholder="New Market Line Value:"
					step="0.1"
					min="1"
					errors={errors && errors.new_market_line_value}
					on:change={(event) => (newMarketLineValue = parseFloat(event.target.value).toFixed(1))}
					on:keyup={(event) => {
						if (event.keyCode === 13) {
							newMarketLineValue = parseFloat(event.target.value).toFixed(1);
						}
					}}
					value={newMarketLineValue}
				/>
			</div>
			<LoadingButton on:click={updateMarketLineValue} loading={sending} className="mb-4 btn btn-primary-action"
				>Update
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click|preventDefault={() => (open = false)}> Cancel</button>
		</div>
	</Modal>
{/if}
